import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { NSButtonBlue, NSLoading, NSSection } from 'namirasoft-site-react';
import { NSARouterMakerResult } from 'namirasoft-account-react';
import { GatewayType, InvoiceRow } from 'namirasoft-payment';
import { PaymentLayout } from '../PaymentLayout';
import { PaymentProps } from '../PaymentProps';
import { PaymentRoutes } from '../PaymentRoutes';
import NSPInvoiceCard from '../components/NSPInvoiceCard';
import NSPPaymentMethod from '../components/NSPPaymentMethod';
import { EncodingOperation } from 'namirasoft-core';

interface InvoiceGatewayPageProps extends NSARouterMakerResult, PaymentProps
{ }

export interface InvoiceGatewayPageState 
{
	invoice: InvoiceRow | null;
}

function InvoiceGatewayPage(props: InvoiceGatewayPageProps)
{
	let NSPPaymentMethodRef = useRef<NSPPaymentMethod>(null);
	let [state, setState] = useState<InvoiceGatewayPageState>({ invoice: null });
	let params = useParams();

	useEffect(() =>
	{
		if (params.id)
			props.servers.payment.invoice.Get(params.id).then((invoice =>
			{
				setState(prevState => ({ ...prevState, invoice }));
			}
			)).catch(() => { });
		// eslint-disable-next-line react-hooks/exhaustive-deps 
	}, []);

	async function onClick(onFinished: () => void)
	{
		try
		{
			if (!state.invoice?.id)
				return;
			let callback = props.url.getQuery("callback");
			if (callback)
				try
				{
					callback = EncodingOperation.Base64Decode(callback);
				} catch (error)
				{
					callback = "";
				}
			if (!callback)
				callback = EncodingOperation.Base64Encode(PaymentRoutes.InvoiceView(state.invoice?.id, false, ""));
			let cancel_url: string = `${window.location.origin}${PaymentRoutes.PaymentCanceled(true, callback)}`;
			let success_url: string = `${window.location.origin}${PaymentRoutes.PaymentSuccessful(true, callback)}`;

			let gateway = NSPPaymentMethodRef.current?.getValue() ?? GatewayType.Stripe;

			try
			{
				let res = await props.servers.payment.invoice.Checkout(state.invoice.id,
					{
						gateway,
						cancel_url: `${window.location.origin}${cancel_url}`,
						success_url: `${window.location.origin}${success_url}`,
						amount: null
					});
				if (res)
					window.location.href = res.url;
				else
					window.location.href = success_url;
			}
			catch
			{
				// The server already reported the error through the notifier.
				window.location.href = cancel_url;
			}
		}
		catch (error)
		{
			// Input validation and local errors are not reported by the server, so notify here.
			props.notifier.onError(error as Error);
		}
		finally
		{
			onFinished();
		}
	}

	function onClickedRadio(title: string)
	{
		if (title)
			setState(prevState => ({ ...prevState, selectedGateway: title as GatewayType, selectedRadio: title }));
	}

	return (
		<PaymentLayout {...props}
			action={{
				title: 'Invoice Gateway',
				description: 'Choose your preferred payment method.',
				menus: {}
			}}
		>
			<NSSection>
				{
					state.invoice ? params.id &&
						<>
							<NSPInvoiceCard {...props} invoice={state.invoice} />
							<NSPPaymentMethod
								ref={NSPPaymentMethodRef}
								{...props}
								onClickedRadio={onClickedRadio}
							/>
							<NSButtonBlue
								title='Continue'
								onClick={{
									action: onClick,
									showLoading: true
								}}
							/>
						</>
						:
						<NSLoading />
				}
			</NSSection>
		</PaymentLayout >
	);
}

export default InvoiceGatewayPage;